export const iconFontAwesomeFilmVideoTicket = (
	<i className="fa-solid fa-ticket"></i>
);
